// extracted by mini-css-extract-plugin
export var container = "dG_c";
export var fadeDiv = "dG_hj";
export var placeholderWrapper = "dG_rV";
export var video = "dG_rW";
export var videoWrapper = "dG_kB";
export var vimeoPlayer = "dG_rX";
export var wrapper = "dG_C";